import React from "react"
import { motion, AnimatePresence } from "framer-motion"
import { X } from "lucide-react"
import FilterBody from "../FilterBody"

const MobileFilterSheet = ({ open, onClose, resultCount, ...filterProps }) => {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 z-40 bg-[#26303D]/50 md:hidden"
          />
          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 28, stiffness: 280 }}
            className="fixed left-0 right-0 bottom-0 z-50 md:hidden bg-white rounded-t-2xl max-h-[85vh] flex flex-col"
          >
            <div className="flex items-center justify-between px-4 pt-4 pb-2 shrink-0">
              <span className="w-8" />
              <span className="w-10 h-1 rounded-full bg-[#DCE1E8]" />
              <button onClick={onClose} aria-label="Close filters" className="text-[#7C8697]">
                <X size={20} />
              </button>
            </div>
            <div className="px-4 pb-4 overflow-y-auto">
              <FilterBody {...filterProps} />
            </div>
            <div className="shrink-0 p-4 border-t border-[#E7EAEF]">
              <button
                onClick={onClose}
                className="w-full py-3 rounded-xl bg-[#FF6B3D] text-white text-sm font-medium"
              >
                Show {resultCount} tours
              </button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}

export default MobileFilterSheet
